import React, { useState } from "react";
import "./index.css";
import UploadModal from "./UploadModal";

const FilesUploader = ({ folder, buttonTitle = "Upload Files", Uploader }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <button className="button is-primary is-small" onClick={() => setIsOpen(true)}>
        {buttonTitle}
      </button>
      <UploadModal isOpen={isOpen} folder={folder} toggleModal={(isOpen) => setIsOpen(isOpen)} Uploader={Uploader} />
    </div>
  );
};

export default FilesUploader;
